const getChartData = ({
  true_positive,
  true_negative,
  false_positive,
  false_negative,
}) => {
  const positive = true_positive + false_negative;
  const negative = true_negative + false_positive;
  const total = positive + negative;

  return [
    {
      name: "Positive",
      value: positive,
      percent: (Math.round((positive + Number.EPSILON) * 100) / total).toFixed(
        2
      ),
      cellProps: { fill: "#6EE7B7" },
    },
    {
      name: "Negative",
      value: negative,
      percent: (Math.round((negative + Number.EPSILON) * 100) / total).toFixed(
        2
      ),
      cellProps: { fill: "#FCA5A5" },
    },
  ];
};

const getChartTotal = data =>
  data.reduce((total, entry) => total + entry.value, 0);

export { getChartData, getChartTotal };
